import React, { useContext, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { gold } from "../../App";
import LaunchIcon from "@mui/icons-material/Launch";
import {
  isImplantedEmbryo,
  isEmpty,
  isFrozenEmbryo,
  isFoal,
  isBroodmareEmpty,
  isYearling,
  isBroodmareFull,
} from "../../utils/Utils";
import { useSelector } from "react-redux";
import Slider from "./Slider";
import { UidContext } from "../AppContext";
import { Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Chrono, whenFunction } from "../Chrono";
import useIsMobile from "../../utils/useIsMobile";
import useSEO from "../../utils/useSEO";
import ShareLot from "./ShareLot";
import NoTranslate from "../NoTranslate";

export default function Lot() {
  const [lot, setLot] = useState();
  let params = useParams();
  const user = useSelector((state) => state.userReducer);
  const [t, i18n] = useTranslation();

  let prevLot;

  function fetchLot() {
    axios
      .get(`${process.env.REACT_APP_API_URL}api/lot/${params.id}`)
      .then((res) => {
        console.log("<!> : fetchLot -> res.data", res.data);
        if (res.data && JSON.stringify(prevLot) !== JSON.stringify(res.data)) {
          setLot(res.data);

          prevLot = res.data;
        }
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    fetchLot();
    const interval = setInterval(() => fetchLot(), 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // SEO et métadonnées pour le partage
  useSEO({
    title: lot ? `Lot ${lot.number} - ${lot.title}` : null,
    description: lot
      ? `${lot.title}. Vente de chevaux de sport et d'élevage sur Alpha Mares. Prix de départ: ${lot.price}€`
      : null,
    image:
      lot && lot.pictures && lot.pictures[0]
        ? `${process.env.REACT_APP_API_URL}${lot.pictures[0]}`
        : null,
    url: lot ? `${window.location.origin}/lot/${lot._id}` : null,
  });

  return (
    <div className="page page-lot">
      {!isEmpty(lot) && (
        <div className="lot">
          <div className="presentation">
            <div className="left">
              <div className="lot-actions">
                <NavLink to={`/auction/${lot.auction}`}>
                  <button className="btn">{t("Lot.Back-Catalog")}</button>
                </NavLink>
                <ShareLot lot={lot} />
              </div>
              <br />
              {isBroodmareFull(lot) || isBroodmareEmpty(lot) ? (
                <h3 translate="no">
                  Lot {lot.number} - {t("Lot." + lot.type)}
                </h3>
              ) : (
                <h3 translate="no">
                  Lot {lot.number} - {t("Lot." + lot.type)} -{" "}
                  {t("Lot." + lot.sexe)}
                </h3>
              )}
              <h2>{i18n.language === "fr-FR" ? lot.title : lot.titleEN}</h2>
            </div>
            <BidPanel lot={lot} user={user} fetchLot={fetchLot} />
          </div>
          <br />
          <div className="images-and-pedigree">
            <Slider lot={lot} />
            <Pedigree lot={lot} />
          </div>
          <br />
          <LotInfos lot={lot} />
        </div>
      )}
    </div>
  );
}

function Pedigree(props) {
  const lot = props.lot;
  return (
    <div className="pedigree" translate="no">
      <div
        style={{
          height: "95%",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              borderBottom: "3px solid #0c3c3c",
              height: "50%",
            }}
          >
            <div
              style={{
                flexGrow: 0.5,
                maxWidth: "33%",
              }}
            >
              <h4>{lot.pedigree.gen1.father}</h4>
            </div>
            <div
              style={{
                flexGrow: 2.5,
                maxWidth: "66%",
                height: "100%",
                alignContent: "center",
              }}
            >
              <div
                style={{
                  borderBottom: "3px solid #0c3c3c",
                  width: "100%",
                  height: "50%",
                  alignContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignContent: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      maxWidth: "50%",
                    }}
                  >
                    <h4>{lot.pedigree.gen2.GFPaternal}</h4>
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      maxWidth: "50%",
                      height: "100%",
                      alignContent: "center",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "3px solid #0c3c3c",
                        height: "50%",
                        alignContent: "center",
                      }}
                    >
                      <h4>{lot.pedigree.gen3.GGFPF}</h4>
                    </div>
                    <div
                      style={{
                        height: "50%",
                        alignContent: "center",
                      }}
                    >
                      <h4>{lot.pedigree.gen3.GGMPF}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  height: "50%",
                  alignContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignContent: "center",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      maxWidth: "50%",
                    }}
                  >
                    <h4>{lot.pedigree.gen2.GMPaternal}</h4>
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      maxWidth: "50%",
                      height: "100%",
                      alignContent: "center",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "3px solid #0c3c3c",
                        height: "50%",
                        alignContent: "center",
                      }}
                    >
                      <h4>{lot.pedigree.gen3.GGFMF}</h4>
                    </div>
                    <div
                      style={{
                        height: "50%",
                        alignContent: "center",
                      }}
                    >
                      <h4>{lot.pedigree.gen3.GGMMF}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <hr /> */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              height: "50%",
            }}
          >
            <div
              style={{
                flexGrow: 0.5,
                maxWidth: "33%",
              }}
            >
              <h4>{lot.pedigree.gen1.mother}</h4>
            </div>
            <div
              style={{
                flexGrow: 2.5,
                maxWidth: "66%",
                alignContent: "center",
                height: "100%",
              }}
            >
              <div
                style={{
                  borderBottom: "3px solid #0c3c3c",
                  height: "50%",
                  alignContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignContent: "center",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      maxWidth: "50%",
                    }}
                  >
                    <h4>{lot.pedigree.gen2.GFMaternal}</h4>
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      maxWidth: "50%",
                      height: "100%",
                      alignContent: "center",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "3px solid #0c3c3c",
                        height: "50%",
                        alignContent: "center",
                      }}
                    >
                      <h4>{lot.pedigree.gen3.GGFPM}</h4>
                    </div>
                    <div
                      style={{
                        height: "50%",
                        alignContent: "center",
                      }}
                    >
                      <h4>{lot.pedigree.gen3.GGMPM}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  height: "50%",
                  alignContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignContent: "center",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      maxWidth: "50%",
                    }}
                  >
                    <h4>{lot.pedigree.gen2.GMMaternal}</h4>
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      maxWidth: "50%",
                      height: "100%",
                      alignContent: "center",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "3px solid #0c3c3c",
                        height: "50%",
                        alignContent: "center",
                      }}
                    >
                      <h4>{lot.pedigree.gen3.GGFMM}</h4>
                    </div>
                    <div
                      style={{
                        height: "50%",
                        alignContent: "center",
                      }}
                    >
                      <h4>{lot.pedigree.gen3.GGMMM}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  // return (
  //   <div className="pedigree">
  //     <div className="pedigree-container">
  //       <div className="row">
  //         <div className="col">
  //           <h4>{lot.pedigree.gen1.father}</h4>
  //         </div>
  //         <div className="col">
  //           <h4>{lot.pedigree.gen2.GFPaternal}</h4>
  //           <hr />
  //           <h4>{lot.pedigree.gen2.GMPaternal}</h4>
  //         </div>
  //         <div className="col">
  //           <h4>{lot.pedigree.gen3.GGFPF}</h4>
  //           <hr />
  //           <h4>{lot.pedigree.gen3.GGMPF}</h4>
  //           <hr />
  //           <h4>{lot.pedigree.gen3.GGFMF}</h4>
  //           <hr />
  //           <h4>{lot.pedigree.gen3.GGMMF}</h4>
  //         </div>
  //       </div>

  //       <hr />

  //       <div className="row">
  //         <div className="col">
  //           <h4>{lot.pedigree.gen1.mother}</h4>
  //         </div>
  //         <div className="col">
  //           <h4>{lot.pedigree.gen2.GFMaternal}</h4>
  //           <hr />
  //           <h4>{lot.pedigree.gen2.GMMaternal}</h4>
  //         </div>
  //         <div className="col">
  //           <h4>{lot.pedigree.gen3.GGFPM}</h4>
  //           <hr />
  //           <h4>{lot.pedigree.gen3.GGMPM}</h4>
  //           <hr />
  //           <h4>{lot.pedigree.gen3.GGFMM}</h4>
  //           <hr />
  //           <h4>{lot.pedigree.gen3.GGMMM}</h4>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
}

export function BidPanel(props) {
  const userData = props.user;
  const lot = props.lot;
  const [terms, setTerms] = useState(false);
  const [step, setStep] = useState(0);
  const [bidPlus, setBidPlus] = useState(0);
  const [notBidderAnymore, setNotBidderAnymore] = useState(false);
  const { uid } = useContext(UidContext);
  const [t] = useTranslation();

  function stepCalcul() {
    var stepVar;
    if (isEmpty(lot.lastBid)) {
      if (lot.price < 1000) stepVar = 100;
      if (lot.price >= 1000 && 20000 > lot.price) stepVar = 500;
      if (lot.price >= 20000 && 50000 > lot.price) stepVar = 1000;
      if (50000 <= lot.price) stepVar = 2000;
    } else {
      if (lot.lastBid.amount < 1000) stepVar = 100;
      if (lot.lastBid.amount >= 1000 && 20000 > lot.lastBid.amount)
        stepVar = 500;
      if (lot.lastBid.amount >= 20000 && 50000 > lot.lastBid.amount)
        stepVar = 1000;
      if (50000 <= lot.lastBid.amount) stepVar = 2000;
    }
    setStep(stepVar);
    setBidPlus(stepVar);
  }

  function subBid() {
    if (bidPlus > step) {
      setBidPlus(bidPlus - step);
    }
  }

  function addBid() {
    setBidPlus(step + bidPlus);
  }

  function handleTerms(event) {
    setTerms(event.target.checked);
  }

  const sendBid = async () => {
    if (terms && bidPlus >= step) {
      setTerms(false);
      const bid = {
        bidderId: userData._id,
        auctionId: lot.auction,
        lotId: lot._id,
        amount: isEmpty(lot.lastBid)
          ? lot.price + bidPlus
          : lot.lastBid.amount + bidPlus,
      };
      await axios
        .post(`${process.env.REACT_APP_API_URL}api/bid`, bid)
        .then(() => props.fetchLot())
        .catch((err) => console.log(err));
    }
  };

  function numberWithPoint(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function wasBidder(lot, uid) {
    if (!isEmpty(lot.bids)) {
      lot.bids.forEach((bid) => {
        if (bid.bidderId === uid) {
          setNotBidderAnymore(true);
        }
      });
    } else {
      setNotBidderAnymore(false);
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => stepCalcul(), [step, lot.lastBid, lot.price]);
  useEffect(() => {
    wasBidder(lot, uid);
  }, [lot, uid]);

  const [when, setWhen] = useState();

  useEffect(() => {
    if (lot) {
      setWhen(whenFunction(lot.start, lot.end));
      const interval = setInterval(() => {
        setWhen(whenFunction(lot.start, lot.end));
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [lot]);

  return (
    // Infos de prix (avant/pendant la vente) et action d'enchérir : conservées
    // dans la langue affichée (FR/EN), non traduites par les plugins type Google Translate.
    <div className="bidPanel" translate="no">
      {when === "now" && !isEmpty(uid) && userData.blocked && (
        <div className="bidPanel-container">
          <div className="blob">
            <h1>{t("Lot.Panel.Current-Auction")}</h1>
            {isEmpty(lot.lastBid) ? (
              <h1 className="moove">{numberWithPoint(lot.price)} €</h1>
            ) : (
              <h1 className="moove">{numberWithPoint(lot.lastBid.amount)} €</h1>
            )}
          </div>
          <h2>
            {t("Lot.Panel.Ends-In")}
            <br />{" "}
            <strong>
              <Chrono start={lot.start} end={lot.end} />
            </strong>
          </h2>
          <h2>{t("Lot.Panel.Blocked-Account")}</h2>
        </div>
      )}
      {when === "now" && !isEmpty(uid) && !userData.blocked && (
        <div className="bidPanel-container">
          {!isEmpty(lot.lastBid) ? (
            lot.lastBid.bidderId === uid ? (
              <div className="YouFirst">{t("Lot.Panel.You-Are-Holder")}</div>
            ) : notBidderAnymore ? (
              <div
                className="YouFirst"
                style={{
                  backgroundColor: "red",
                  color: "white",
                  width: "100%",
                }}
              >
                {t("Lot.Panel.You-Are-Not-Holder-Anymore")}
              </div>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
          <div className="blob">
            <h1>{t("Lot.Panel.Current-Auction")}</h1>
            {isEmpty(lot.lastBid) ? (
              <h1 className="moove">{numberWithPoint(lot.price)} €</h1>
            ) : (
              <h1 className="moove">{numberWithPoint(lot.lastBid.amount)} €</h1>
            )}
          </div>
          <h2>
            {t("Lot.Panel.Ends-In")}
            <br />{" "}
            <strong>
              <Chrono start={lot.start} end={lot.end} />
            </strong>
          </h2>
          <div className="terms-container">
            <input
              type="checkbox"
              id="terms"
              onChange={handleTerms}
              value={terms}
              checked={terms}
            />
            <label htmlFor="terms">
              {t("Lot.Panel.I-Accept")}{" "}
              <a
                href={`${process.env.REACT_APP_API_URL}legals/CGU.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("Lot.Panel.CGU")}
              </a>
              .
            </label>
          </div>
          <div className="btn-container">
            <div className="btn-add-sub">
              <div className="btna" onClick={subBid}>
                -
              </div>
              {isEmpty(lot.lastBid) ? (
                <h3>{numberWithPoint(lot.price + bidPlus)} €</h3>
              ) : (
                <h3>{numberWithPoint(lot.lastBid.amount + bidPlus)} €</h3>
              )}
              <div className="btna" onClick={addBid}>
                +
              </div>
            </div>
            <div className="btn-lot">
              <button disabled={!terms || bidPlus === 0} onClick={sendBid}>
                {t("Lot.Panel.Bid")}{" "}
              </button>
            </div>
          </div>
        </div>
      )}
      {when === "now" && isEmpty(uid) && !userData.blocked && (
        <div className="bidPanel-container">
          <div className="blob">
            <h1>{t("Lot.Panel.Current-Auction")}</h1>
            {isEmpty(lot.lastBid) ? (
              <h1 className="moove">{numberWithPoint(lot.price)} €</h1>
            ) : (
              <h1 className="moove">{numberWithPoint(lot.lastBid.amount)} €</h1>
            )}
          </div>
          <h2>
            {t("Lot.Panel.Ends-In")} <br />{" "}
            <strong>
              <Chrono start={lot.start} end={lot.end} />
            </strong>
          </h2>
          <div className="btn-container">
            <NavLink className="btn moove" to="/profil" state={"sign-up"}>
              {t("Lot.Panel.Create-Account")}
            </NavLink>
          </div>
        </div>
      )}
      {when === "coming" && isEmpty(uid) && (
        <div className="bidPanel-container">
          <div className="blob">
            <h1 style={{ whiteSpace: "nowrap" }}>
              {t("Lot.Panel.Start-Auction")}
            </h1>
            <h1>{numberWithPoint(lot.price)}€</h1>
          </div>
          <div>
            <h5 style={{ fontWeight: "100" }}>{t("Lot.Panel.In")}</h5>
            <h5>
              <Chrono start={lot.start} end={lot.end} />
            </h5>
          </div>
          <div className="btn-container">
            <NavLink className="btn moove" to="/profil" state={"sign-up"}>
              {t("Lot.Panel.Create-Account")}
            </NavLink>
          </div>
        </div>
      )}
      {when === "coming" && !isEmpty(uid) && (
        <div className="bidPanel-container">
          <div className="blob">
            <h1 style={{ whiteSpace: "nowrap" }}>
              {t("Lot.Panel.Start-Auction")}
            </h1>
            <h1>{numberWithPoint(lot.price)}€</h1>
          </div>
          <div>
            <h5 style={{ fontWeight: "100" }}>{t("Lot.Panel.In")}</h5>
            <h5>
              <Chrono start={lot.start} end={lot.end} />
            </h5>
          </div>
        </div>
      )}
      {when === "passed" && (
        <div className="bidPanel-container">
          {!isEmpty(lot.lastBid) && lot.lastBid.bidderId === uid && (
            <div className="YouFirst">{t("Lot.Panel.You-Are-Winner")}</div>
          )}
          <div className="blob">
            <h1>{t("Lot.Panel.Last-Auction")}</h1>
            {isEmpty(lot.lastBid) ? (
              <h1>{numberWithPoint(lot.price)} €</h1>
            ) : (
              <h1>{numberWithPoint(lot.lastBid.amount)}€</h1>
            )}
          </div>
          <div>
            <h5 style={{ fontWeight: "100" }}>{t("Lot.Panel.Finished")}</h5>
          </div>
        </div>
      )}
    </div>
  );
}

function LotInfos(props) {
  const isMobile = useIsMobile(700);

  const [index, setIndex] = useState(0);
  const lot = props.lot;
  const [openTVA, setOpenTVA] = React.useState(false);
  const { t, i18n } = useTranslation();

  const handleClickOpen = () => {
    setOpenTVA(true);
  };

  const handleClose = () => {
    setOpenTVA(false);
  };

  const handleChange = (event, newIndex) => {
    setIndex(newIndex);
  };

  const formatBR = (text) => {
    return text.split("\n").map((txt, id) => {
      return (
        <React.Fragment key={`${txt}-${id}`}>
          {txt}
          <br />
        </React.Fragment>
      );
    });
  };

  function InfoMobile() {
    // console.log(`💥 ~: lot`, lot);
    return (
      <div>
        {isFrozenEmbryo(lot) && (
          <div className="row general-infos">
            <h4>
              <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Sexe")}</strong> {t("Lot." + lot.sexe)}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Production-Date")}</strong>{" "}
              {moment(lot.productionDate).format("LL")}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
            </h4>
            <h4>
              <strong>{t("Lot.Field.Seller")}</strong>{" "}
              {i18n.language === "en-EN"
                ? lot.sellerNationality
                : t("Nation." + lot.sellerNationality)}{" "}
              ({t("Lot." + lot.sellerType)})
            </h4>
            <h4>
              <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
              <p onClick={handleClickOpen} className="calcul-TVA">
                {t("Lot.Field.Calculs-TVA")}
              </p>
            </h4>
          </div>
        )}

        {isImplantedEmbryo(lot) && (
          <div className="row general-infos">
            <h4>
              <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Sexe")}</strong> {t("Lot." + lot.sexe)}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Due-Date")}</strong>{" "}
              {moment(lot.dueDate).format("LL")}{" "}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
            </h4>
            <h4>
              <strong>{t("Lot.Field.Reproduction-Type")}</strong>{" "}
              {lot.reproduction}
            </h4>
            {lot.reproduction === "ICSI" || lot.reproduction === "Transfer" ? (
              <h4>
                <strong>{t("Lot.Field.Age-Carrier")}</strong> {lot.carrierAge}{" "}
                {t("Lot.Field.Years")}
              </h4>
            ) : (
              <h4 style={{ whiteSpace: "normal", textAlign: "justify" }}>
                {t("Lot.Field.Carrier-Infos")}
              </h4>
            )}
            {(lot.reproduction === "ICSI" ||
              lot.reproduction === "Transfer") && (
              <h4>
                <strong>{t("Lot.Field.Carrier-Size")}</strong> {lot.carrierSize}{" "}
                cm
              </h4>
            )}
            {(lot.reproduction === "ICSI" ||
              lot.reproduction === "Transfer") && (
              <h4>
                <strong>{t("Lot.Field.Carrier-Deposit")}</strong>{" "}
                {lot.carrierForSale ? lot.bondCarrier : ""} €
              </h4>
            )}
            {(lot.reproduction === "ICSI" ||
              lot.reproduction === "Transfer") && (
              <h4>
                <strong>{t("Lot.Field.Carrier-For-Sale")}</strong>{" "}
                {lot.carrierForSale === "Yes"
                  ? t("Lot.Field.Yes")
                  : t("Lot.Field.No")}
              </h4>
            )}
            <h4>
              <strong>{t("Lot.Field.Seller")}</strong>{" "}
              {i18n.language === "en-EN"
                ? lot.sellerNationality
                : t("Nation." + lot.sellerNationality)}{" "}
              ({t("Lot." + lot.sellerType)})
            </h4>

            <h4>
              <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
              <p onClick={handleClickOpen} className="calcul-TVA">
                {t("Lot.Field.Calculs-TVA")}
              </p>
            </h4>
          </div>
        )}

        {isFoal(lot) && (
          <div className="row general-infos">
            <h4>
              <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Sexe")}</strong> {t("Lot." + lot.sexe)}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
            </h4>
            <h4>
              <strong>{t("Lot.Field.Reproduction-Type")}</strong>{" "}
              {lot.reproduction}
            </h4>
            <h4>
              <strong>{t("Lot.Field.Seller")}</strong>{" "}
              {i18n.language === "en-EN"
                ? lot.sellerNationality
                : t("Nation." + lot.sellerNationality)}{" "}
              ({t("Lot." + lot.sellerType)})
            </h4>
            <h4>
              <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
            </h4>
            <h4>
              <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
              {moment(lot.birthDate).format("LL")}
            </h4>
            <h4>
              <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
              <p onClick={handleClickOpen} className="calcul-TVA">
                {t("Lot.Field.Calculs-TVA")}
              </p>
            </h4>
          </div>
        )}

        {isBroodmareEmpty(lot) && (
          <div className="row general-infos">
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate, "DDMMYYYY").format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Size")}</strong>{" "}
                {lot.size ? lot.size : "-"} cm
              </h4>
              <h4>
                <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div>
            {/* <div className="col">
              <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate).format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Size")}</strong>{" "}
                {lot.size ? lot.size : "-"} cm
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div> */}
          </div>
        )}

        {isBroodmareFull(lot) && (
          <div className="row general-infos">
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate, "DDMMYYYY").format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Size")}</strong>{" "}
                {lot.size ? lot.size : "-"} cm
              </h4>
              <h4>
                <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Due-Date")}</strong>{" "}
                {moment(lot.dueDate).format("LL")}{" "}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Selected-Stallion")}</strong>{" "}
                <NoTranslate>{lot.fatherFoal}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
            </div>
            <div className="col">
              {/* <h4>
                <strong>{t("Lot.Field.Sexe")}</strong> {t("Lot." + lot.sexe)}
              </h4> */}
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div>
          </div>
        )}

        {isYearling(lot) && (
          <div className="row general-infos">
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate).format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div>
          </div>
        )}
        <br />

        {!isEmpty(lot.commentFR) && !isEmpty(lot.commentEN) && (
          <div className="comment">
            <h4>
              <strong>{t("Lot.Field.Comment")}</strong>
            </h4>
            <h4>
              {i18n.language === "en-EN"
                ? formatBR(lot.commentEN)
                : formatBR(lot.commentFR)}
            </h4>
          </div>
        )}

        <br />
        <div className="insurance">
          <h3>{t("Lot.Insurer1")}</h3>
          <h3>
            {t("Lot.Insurer2")}
            <a href="tel:+33633346654">+33 6 33 34 66 54</a>
          </h3>
        </div>
        <br />
        <TVADialog open={openTVA} onClose={handleClose} />
      </div>
    );
  }

  function Info() {
    return (
      <div>
        {isFrozenEmbryo(lot) && (
          <div className="row general-infos">
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Production-Date")}</strong>{" "}
                {moment(lot.productionDate).format("LL")}
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Sexe")}</strong> {t("Lot." + lot.sexe)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div>
          </div>
        )}

        {isImplantedEmbryo(lot) && (
          <div className="row general-infos">
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
              {lot.reproduction === "ICSI" ||
              lot.reproduction === "Transfer" ? (
                <h4>
                  <strong>{t("Lot.Field.Age-Carrier")}</strong> {lot.carrierAge}{" "}
                  {t("Lot.Field.Years")}
                </h4>
              ) : (
                <h4 style={{ whiteSpace: "normal", textAlign: "justify" }}>
                  {t("Lot.Field.Carrier-Infos")}
                </h4>
              )}
              {(lot.reproduction === "ICSI" ||
                lot.reproduction === "Transfer") && (
                <h4>
                  <strong>{t("Lot.Field.Carrier-Deposit")}</strong>{" "}
                  {lot.carrierForSale ? lot.bondCarrier : ""} €
                </h4>
              )}
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Sexe")}</strong> {t("Lot." + lot.sexe)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Reproduction-Type")}</strong>{" "}
                {lot.reproduction}
              </h4>
              {(lot.reproduction === "ICSI" ||
                lot.reproduction === "Transfer") && (
                <>
                  <h4>
                    <strong>{t("Lot.Field.Carrier-Size")}</strong>{" "}
                    {lot.carrierSize} cm
                  </h4>
                  <h4>
                    <strong>{t("Lot.Field.Carrier-For-Sale")}</strong>{" "}
                    {lot.carrierForSale === "Yes"
                      ? t("Lot.Field.Yes")
                      : t("Lot.Field.No")}
                  </h4>
                </>
              )}
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
              <h4>
                <strong>{t("Lot.Field.Due-Date")}</strong>{" "}
                {moment(lot.dueDate).format("LL")}{" "}
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div>
          </div>
        )}

        {isFoal(lot) && (
          <div className="row general-infos">
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Reproduction-Type")}</strong>{" "}
                {lot.reproduction}
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Sexe")}</strong> {t("Lot." + lot.sexe)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
              <h4>
                <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate).format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div>
          </div>
        )}

        {isBroodmareEmpty(lot) && (
          <div className="row general-infos">
            <div className="col">
              {/* <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
              </h4> */}
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate, "DDMMYYYY").format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Size")}</strong>{" "}
                {lot.size ? lot.size : "-"} cm
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
              {/* <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate).format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4> */}
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
              {/* <h4>
                <strong>{t("Lot.Field.Size")}</strong>{" "}
                {lot.size ? lot.size : "-"} cm
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4> */}
            </div>
          </div>
        )}

        {isBroodmareFull(lot) && (
          <div className="row general-infos">
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate, "DDMMYYYY").format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Size")}</strong>{" "}
                {lot.size ? lot.size : "-"} cm
              </h4>
              <h4>
                <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Due-Date")}</strong>{" "}
                {moment(lot.dueDate).format("LL")}{" "}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Selected-Stallion")}</strong>{" "}
                <NoTranslate>{lot.fatherFoal}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
              <h4>&nbsp;</h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>

              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div>
          </div>
        )}

        {isYearling(lot) && (
          <div className="row general-infos">
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Type")}</strong> {t("Lot." + lot.type)}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Location")}</strong>{" "}
              <NoTranslate>{lot.location}</NoTranslate>
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Birthdate")}</strong>{" "}
                {moment(lot.birthDate).format("LL")}
              </h4>
              <h4>
                <strong>{t("Lot.Field.Seller")}</strong>{" "}
                {i18n.language === "en-EN"
                  ? lot.sellerNationality
                  : t("Nation." + lot.sellerNationality)}{" "}
                ({t("Lot." + lot.sellerType)})
              </h4>
            </div>
            <div className="col">
              <h4>
                <strong>{t("Lot.Field.Race")}</strong>{" "}
              <NoTranslate>{lot.race}</NoTranslate>
              </h4>
              <h4>
                <strong>{t("Lot.Field.TVA")}</strong> {lot.tva} %{" "}
                <p onClick={handleClickOpen} className="calcul-TVA">
                  {t("Lot.Field.Calculs-TVA")}
                </p>
              </h4>
            </div>
          </div>
        )}
        <br />

        {!isEmpty(lot.commentFR) && !isEmpty(lot.commentEN) && (
          <div className="comment">
            <h4>
              <strong>{t("Lot.Field.Comment")}</strong>
            </h4>
            <h4>
              {i18n.language === "en-EN"
                ? formatBR(lot.commentEN)
                : formatBR(lot.commentFR)}
            </h4>
          </div>
        )}

        <br />
        <div className="insurance">
          <h3>{t("Lot.Insurer1")}</h3>
          <h3>
            {t("Lot.Insurer2")}
            <a href="tel:+33633346654">+33 6 33 34 66 54</a>
          </h3>
        </div>
        <br />
        <TVADialog open={openTVA} onClose={handleClose} />
      </div>
    );
  }

  const BlackType = React.memo(() => {
    return (
      lot.blackType && (
        <object
          data={`${process.env.REACT_APP_API_URL}${lot.blackType}`}
          width="100%"
          height="1000vh"
          type="application/pdf"
          style={{ backgroundColor: "white" }}
        >
          <a
            href={`${process.env.REACT_APP_API_URL}${lot.blackType}`}
            target="_blank"
            style={{
              textDecoration: "underline",
              color: "white",
              backgroundColor: "#0c3c3c",
            }}
            rel="noreferrer"
          >
            Pedigree Black Type
          </a>
        </object>
      )
    );
  });

  function VetDocs() {
    return (
      <div>
        <h2>{t("Lot.Vet-Doc")} :</h2>
        <br />
        <div className="veterinaryDocs">
          {!isEmpty(lot.veterinaryDocuments) &&
            lot.veterinaryDocuments.map((doc) => {
              return (
                <div key={doc} className="doc">
                  <a
                    href={`${process.env.REACT_APP_API_URL}${doc}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn"
                  >
                    <div className="doc-title">
                      {doc
                        .split(".pdf")[0]
                        .split("Lot_")
                        .pop()
                        .split("_")
                        .slice(1)}
                    </div>
                    <LaunchIcon />
                  </a>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  return (
    <div className="lot-infos">
      <Tabs
        value={index}
        onChange={handleChange}
        sx={{
          "& .MuiTabs-indicator": { backgroundColor: "transparent" },
          "& .MuiTab-root": {
            color: "white",
            border: "3px solid",
            borderColor: gold,
            borderRadius: "15px",
            margin: "1vw",
          },
          "& .Mui-selected": { color: "black", backgroundColor: gold },
        }}
        centered
      >
        <Tab label={t("Lot.General-Info")} />
        <Tab label={t("Lot.Black-Type")} />
        <Tab label={t("Lot.Vet-Doc")} />
      </Tabs>
      <hr />
      <br />
      {index === 0 && (isMobile ? <InfoMobile /> : <Info />)}
      {index === 1 && <BlackType />}
      {index === 2 && <VetDocs />}
    </div>
  );
}

function TVADialog(props) {
  const { open, onClose } = props;
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} className="dialog-TVA">
      <div className="dialog-TVA">
        <h2>{t("Lot.Dialog-TVA.Title")}</h2>
        <br />
        <ol>
          <li>{t("Lot.Dialog-TVA.1")}</li>
          <li>{t("Lot.Dialog-TVA.2")}</li>
          <li>{t("Lot.Dialog-TVA.3")}</li>
          <li>{t("Lot.Dialog-TVA.4")}</li>
          <li>{t("Lot.Dialog-TVA.5")}</li>
        </ol>
      </div>
    </Dialog>
  );
}
